import axios from "axios";
import React, {useEffect, useState} from "react";
import { Link, useParams } from "react-router-dom";
import "../../../config";

const DetailDataCompOpenData = ({formatDate}) => {
    const { id } = useParams();
    const [dataDetail, setDataDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(global.config.host + `/api/3/action/package_show?id=${id}`);
                setDataDetail(response.data.result);
            } catch (error) {
                console.error('Error fetching data detail', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    return(
        <section className="d-flex align-items-center" style={{marginTop:'60px'}}>
            <div className="container" data-aos="fade-in">
                <div className="row content" data-aos="fade-in">
                    <Link to={`/open_data/kumpulan_data`} className="breadcrumb"><i className="bx bx-arrow-back"></i> Kembali</Link>
                </div>
                {
                    loading ? (
                        <div className="col-md-12 text-center" data-aos="fade-in">
                            <h4>Loading Data...</h4>
                        </div>
                    ) :
                    (
                        <div className="row content" >
                            <div className="col-md-12 m-b-20">
                                <p className="author">
                                    <i className="bx bx-user-circle"></i> {dataDetail.author} | <i className="bx bx-time"></i> {formatDate(dataDetail.metadata_modified)}
                                </p>
                                <h4 className="m-b-10 font-weight-600" >
                                    {dataDetail.title}
                                </h4>
                                <p className="content">
                                    {dataDetail.notes}
                                </p>
                            </div>
                            <div className="col-md-12 m-b-20">
                                <div className="box-org" style={{fontSize:'15px'}}>
                                    <p><b><i className="bx bx-building-house"></i> {dataDetail.organization.title} | <i className="bx bx-user"></i> {dataDetail.organization.type}</b></p>
                                    <p className="m-b-0">{dataDetail.organization.description}</p>
                                </div>
                                
                            </div>
                            <div className="col-md-6">
                                <div className="box-additional">
                                    <div className="header-additional">
                                        <i className="bx bx-info-circle"></i> Additional Information
                                    </div>
                                    <div>
                                        <table className="table table-striped-columns m-b-0">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-100">Author</td>
                                                    <td>{dataDetail.author}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">Last Updated</td>
                                                    <td>{formatDate(dataDetail.metadata_modified)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">Created</td>
                                                    <td>{formatDate(dataDetail.metadata_created)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">a. Nama Variabel</td>
                                                    <td>{
                                                        dataDetail.extras[0] ? dataDetail.extras[0].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">b. Referensi Pemilihan</td>
                                                    <td>{
                                                        dataDetail.extras[1]? dataDetail.extras[1].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">c. Referensi Waktu</td>
                                                    <td>{
                                                        dataDetail.extras[2] ? dataDetail.extras[2].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">d. Tipe Data</td>
                                                    <td>{
                                                        dataDetail.extras[3] ? dataDetail.extras[3].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">e. Klasifikasi Isian</td>
                                                    <td>{
                                                        dataDetail.extras[4] ? dataDetail.extras[4].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">f. Satuan</td>
                                                    <td>{
                                                        dataDetail.extras[5] ? dataDetail.extras[5].value : '-'
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-100">g. Frekuensi Data</td>
                                                    <td>{
                                                        dataDetail.extras[6] ? dataDetail.extras[6].value : '-'
                                                    }</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="box-additional">
                                    <div className="header-additional">
                                        <i className="bx bx-data"></i> Data and Resources
                                    </div>
                                    <div className="p-10 box-additional-body">
                                        {
                                            dataDetail.resources.map((data,index) => (
                                                <Link to={`/open_data/kumpulan_data/${dataDetail.name}/resource/${data.id}`}  className="box-file" key={data.id || index} title={`Detail ${data.name}`}>
                                                    <div className="box-format"><i className={
                                                        data.format.toLowerCase() === 'pdf' ? 'bx bxs-file-pdf' :
                                                        data.format.toLowerCase() === 'docx' ? 'bx bxs-file' :
                                                        'bx bxs-file'
                                                    }></i> </div>
                                                    <div className="m-l-10">
                                                        {data.name}
                                                        <p style={{fontSize:'12px',color:'#a2a2a2'}}><i className="bx bx-time"></i> {formatDate(data.last_modified)}</p>
                                                        
                                                    </div>
                                                </Link>
                                            )) 
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </section>
    )
}

export default DetailDataCompOpenData;